import React from 'react'
import ConstructionIcon from '@mui/icons-material/Construction'
import BaseWidgetProvider from '../../base/BaseWidgetProvider'
import ManufacturingWidget from './ManufacturingWidget'
import ManufacturingWidgetConfiguration from './Configuration/ManufacturingWidgetConfiguration'

/**
 * Provider for the Manufacturing Widget
 * Defines the metadata and creation methods of the widget
 */
class ManufacturingWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'ManufacturingWidgetProvider'

  getName = () => 'Single Device Selector'

  getIcon = () => ConstructionIcon

  createWidget = (props) => <ManufacturingWidget {...props} />

  getWidgetInfo = (columns, cellHeight) => {
    const size = { defaultW: 4, defaultH: 4, minW: 2, minH: 2, maxH: 4 }
    // Assumes super.getWidgetInfo handles base logic correctly
    const info = super.getWidgetInfo(columns, cellHeight, size)
    return {
      ...info,
      hideHeader: true,
      availableWithoutDevice: true
    }
  }

  isClickable = () => true

  onClick = (props) => {
    if (props.data?.device?.id) {
      props.navigateToDeviceId(props.data.device.id)
    }
  }

  getConfigurationInfo = () => {
    return []
  }

  createConfigurationWidget = (data, setData, t_) => {
    return (
      <ManufacturingWidgetConfiguration
        data={data}
        setData={setData}
        t_={t_}
      />
    )
  }
}

export default ManufacturingWidgetProvider
